<!-- SIDENAV HEADER -->
<div id="noteSideNavHeader" fxLayout="column" fxLayoutAlign="space-between start"
     class="header p-24 pb-4" ngClass="mat-accent-bg" ngClass.gt-md="white-fg" style="background-color:transparent;">

    <div class="logo" fxFlex fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon s-32" *fuseIfOnDom>note</mat-icon>
        <span class="logo-text" *fuseIfOnDom >Notes</span>
    </div>

    <div class="account" fxLayout="column" *fuseIfOnDom >
        <div class="pb-36" fxLayout="row">
            <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="parent?.url" aria-label="Back" matTooltip="Back">
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div fxLayout="column" fxLayoutAlign="start start"
                *fuseIfOnDom >
                <div class="h2">
                    {{parent.subjectType||parent.type}}
                </div>
                <div class="subtitle secondary-text">
                    <span>{{parent.summary}}</span>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- / SIDENAV HEADER -->

<!-- SIDENAV CONTENT -->
<div class="content" fusePerfectScrollbar *fuseIfOnDom >

    <div class="p-24">
        <button mat-raised-button fxFlex
                class="mat-accent add-dialog-button"
                (click)="addDialog()"
                [disabled] = "readOnly"
                aria-label="Add Note">
            ADD NOTE
        </button>
    </div>

    <div class="nav">

        <div class="nav-subheader">TYPES</div>

        <div class="nav-item" *ngFor="let type of types">
            <a class="nav-link" matRipple [routerLink]="baseUrl + '/notetype/' + type.handle" routerLinkActive="active" [attr.aria-label]="type.title + ' Notes'">
                <mat-icon class="nav-link-icon" *ngIf="type.icon">{{type.icon}}</mat-icon>
                <span>{{type.title}}</span>
            </a>
        </div>

        <div class="nav-subheader">FILTERS</div>

        <div class="nav-item" *ngFor="let filter of filters">
            <a class="nav-link" matRipple [routerLink]="baseUrl + '/filter/' + filter.handle" routerLinkActive="active" [attr.aria-label]="filter.title + ' Notes'">
                <mat-icon class="nav-link-icon" *ngIf="filter.icon">{{filter.icon}}</mat-icon>
                <span>{{filter.title}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDENAV CONTENT -->
